export const SEARCH_BUTTON_TEXT = "Search packages";
export const CORPORATE_SEARCH_BUTTON_TEXT = "Search trips";
export const OUTBOUND = "Outbound";
export const RETURN = "Return";
